import * as React from "react";
import { SVGProps } from "react";
export function CurrentEmployerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 17.75 16.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.75 9.5H17M8.875 8.25v2.5m3.75-6.25a3.75 3.75 0 0 0-7.5 0m10.625 0H2A1.25 1.25 0 0 0 .75 5.75v8.75A1.25 1.25 0 0 0 2 15.75h13.75A1.25 1.25 0 0 0 17 14.5V5.75a1.25 1.25 0 0 0-1.25-1.25Z"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
